// extracted by mini-css-extract-plugin
export var disclaimerText = "FareCardDisclaimer-module--disclaimer-text--e0144";